// extracted by mini-css-extract-plugin
module.exports = {"successMessage":"SuccessMessage_successMessage__1q7uk","title":"SuccessMessage_title__2jA18","message":"SuccessMessage_message__1F9kd","icon":"SuccessMessage_icon__nYkG6"};